import { Span } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { BasketFormLogic } from "./BasketFormLogic";


export class CostsSummaryTable extends Table
{
    constructor(info: BasketFormLogic)
    {
        const totalDeposits = info.basket.TotalDeposits.value;
        const discounts = info.basket.TotalPriceBeforeDiscounts.value - info.basket.TotalPriceAfterDiscounts.value;

        super([],
            [
                // ["Suma usług przed rabatami", info.basket.TotalPriceBeforeDiscounts.value + " zł brutto"],
                ["Suma zakupów", new Span(info.basket.TotalPriceAfterDiscounts.value + " zł wraz z uwzględnionymi rabatami")],
                ["Suma rabatów", discounts + " zł"],
                ["Suma kaucji", totalDeposits + " zł"],
            ]
        )//.Class("uk-table").WidthPercent(100).WidthAuto().MarginAuto().TextAlignLeft(),
            // ,new Div().TextAlignLeft().PaddingLeft(16).Append(
            //     // new Markdown(`Łącznie do wpłaty: **${info.costs.GetNonReturnableCostsSum().toFixed(2)} zł**`).DisplayInlineBlock(),
            //     // info.basket.IsAnythingToRent.value && new Markdown(`(w tym **${info.costs.GetReturnableCostsSum().toFixed(2)} zł** kaucji zwrotnej)`)
            //     //     .MarginLeft(8).MarginTop(24).DisplayInlineBlock(),
            //     // info.basket.IsAnythingToRent.value && new Markdown(`Do zwrotu po oddaniu sprzętu: **${info.costs.GetReturnableCostsSum().toFixed(2)} zł**`)
            //     //     .DisplayBlock().Margin(0),
            //     info.paymentForm.Is(FormPaymentForm.AllWithCrypto) && new Span(`Wybrano płatność w Bitcoin. Złotówki zostaną przeliczone na kryptowalutę w kolejnym kroku`).MarginLeft(32).Italic()
            // ),
        // )
    }
}
